// third-party
// assets
import { Typography } from "@mui/material";
import {
	I24Support,
	Driving,
	Shop,
	Category,
	Setting2,
	CpuSetting,
} from "iconsax-react";

// type
import { NavItemType } from "types/menu";

// icons
const icons = {
	dashboard: Category,
	documentation: I24Support,
	roadmap: Driving,
	orders: Shop,
	settings: Setting2,
	instruments: CpuSetting,
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const support: NavItemType = {
	id: "Home",
	title: <Typography id="Home" />,
	type: "group",
	children: [
		{
			id: "Accounts",
			title: "Accounts",
			type: "item",
			url: "/",
			icon: icons.dashboard,
		},
		{
			id: "Mimic Settings",
			title: "Mimic Settings",
			type: "item",
			url: "/mimic-settings",
			icon: icons.settings,
		},
		{
			id: "Orders",
			title: "Orders",
			type: "item",
			url: "/orders",
			icon: icons.orders,
		},
		{
			id: "Instruments",
			title: "Instruments",
			type: "item",
			url: "/instruments",
			icon: icons.instruments,
		},
	],
};

export default support;
